import { type RootState } from '../rmsStore'

export default function getUserReducer (state: RootState): UserState {
  return state.usersReducer
}
